module.exports = __webpack_public_path__ + "img/2x.ebc6d51.jpg";